// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__22Evz","modalForm":"UpgradeEpcsModal_modalForm__29Zlv","modalFooter":"UpgradeEpcsModal_modalFooter__1fdRT"};